// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"74943d3241b0c91aab5b","655":"383c589b64d47ea6d9a5"}[chunkId] + ".js";
};